import DataChartConfigGate from './DataChartConfigGate';

export default DataChartConfigGate;
